export interface IServiceTemplate {
  id: string;
  name: string;
  description?: string;
  status: ServiceTemplateStatus;
  categoryId: string;
  categoryName?: string;
  trafficClass?: string;
  applicantType?: string;
  serviceType?: string;
  knowledgeBaseUrl?: string;
  usageCount?: number;
  publishedDate?: string;
  publishedBy?: string;
  createdBy?: string;
  dateCreated?: string;
  updatedBy?: string;
  lastModifiedDate?: string;
}

export interface IServiceTemplateDetails {
  id: string;
  serviceTemplateId: string;
  formDefinition?: Record<string, any>;
  pricing?: Record<string, any>;
  workflowDefinition?: Record<string, any>;
  workflowNextStepsProcessingTime?: Record<string, any>;
  translation?: Record<string, any>;
  nextSteps?: Record<string, any>;
  thirdPartyFormDefinition?: Record<string, any>;
  journeyMapping?: Record<string, any>;
  dateCreated?: string;
  lastModifiedDate?: string;
}

export enum ServiceTemplateStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
}

export interface ICreateServiceTemplateRequest {
  name: string;
  description?: string;
  categoryId: string;
  trafficClass?: string;
  applicantType?: string;
  serviceType?: string;
  knowledgeBaseUrl?: string;
}

export interface IUpdateServiceTemplateRequest {
  name?: string;
  description?: string;
  categoryId: string;
  trafficClass?: string;
  applicantType?: string;
  serviceType?: string;
  knowledgeBaseUrl?: string;
}

export interface IServiceTemplateSummary {
  id: string;
  name: string;
  description?: string;
  status: ServiceTemplateStatus;
  categoryId: string;
  usageCount?: number;
  createdBy?: string;
  publishedDate?: string;
}

export interface IApplyTemplateToChangeRequestRequest {
  templateId: string;
  changeRequestId: string;
}

export interface IServiceTemplateStatistics {
  totalTemplates: number;
  publishedTemplates: number;
  draftTemplates: number;
  mostUsedTemplates: IServiceTemplateSummary[];
}
